export default {"src":"/market-research/_next/static/media/favicon.38ab883a.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};